/* 认证介绍页面 */
<template>
  <div class="certification">
    <div class="top">
      <div class="top-insert">
        <a :href="`${VUE_APP_OLD_BASIC_URL}/my/personal/accountSetting?index=2`">
          <Button type="primary" class="red-btn btn">立即认证</Button>
        </a>

        <p>认证设计师，享受更多权益。</p>
        
        <img src="../assets/certification/1.png" alt />
      </div>
    </div>
    <div class="main">
      <div class="middle">
        <p class="title">认证设计师</p>
        <p class="sub">更多权限</p>
        <img src="../assets/certification/5.png" alt />
      </div>
    </div>
    <div class="bottom">
      <img src="../assets/certification/2.png" alt />
    </div>
    <div class="product">
      <p class="title">恐龙商城</p>
      <p class="sub">恐龙蛋兑换好物</p>
      <img src="../assets/certification/3.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL
    };
  }
};
</script>
<style lang="scss">
.certification {
  width: 100%;
  .top {
    width: 100%;
    background: #94b6ff;
    font-size: 0px;
    .top-insert {
      margin: 0 auto;
      font-size: 0px;
      max-width: 1900px;
      position: relative;
      .btn {
        position: absolute;
        top: 70%;
        left: 19%;
      }
      > p {
        color: #fff;
        font-size: 16px;
        position: absolute;
        top: 85%;
        left: 19%;
      }
      img {
        width: 100%;
      }
    }
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    margin-top: 100px;
    .middle {
      width: 100%;
      text-align: center;
      img {
        width: 100%;
      }
      > p {
        text-align: center;
      }
      .title {
        font-size: 24px;
        font-family: SourceHanSerifSC-SemiBold, SourceHanSerifSC;
        font-weight: 600;
        color: rgba(49, 49, 49, 1);
        margin-top: 100px;
      }
      .sub {
        font-size: 18px;
        font-family: SourceHanSerifSC-SemiBold, SourceHanSerifSC;
        font-weight: 600;
        color: rgba(229, 106, 105, 1);
        margin-top: 10px;
        margin-bottom: 50px;
      }
    }
  }
  .bottom {
    margin: 0 auto;
    font-size: 0px;
    max-width: 1900px;
    margin-top: 100px;
    img {
      width: 100%;
    }
  }
  .product {
    width: 1200px;
    margin: 100px auto;
    text-align: center;
    .title {
      font-size: 24px;
      font-family: SourceHanSerifSC-SemiBold, SourceHanSerifSC;
      font-weight: 600;
      color: rgba(49, 49, 49, 1);
      margin-top: 100px;
    }
    .sub {
      font-size: 18px;
      font-family: SourceHanSerifSC-SemiBold, SourceHanSerifSC;
      font-weight: 600;
      color: rgba(229, 106, 105, 1);
      margin-top: 10px;
      margin-bottom: 50px;
    }
    img {
      width: 100%;
    }
  }
}
</style>    